import { gql } from 'apollo-boost';


export const RESOURCES_QUERY = gql`
query resources {
    resources {
        edges {
            node {
                id
                isPublished
                tagIds
                learningProfileIds
                brandIds
                productIds
                tagIds
                localeIds
                companyRelationshipIds
                resourceLocalizations {
                    edges {
                        node {
                            id
                            localeCode
                            isDefault
                            name
                            description
                            resourceFileId
                            resourceFile {
                                node {
                                    id
                                    genericFile
                                    lxpFile
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
`;